import React from 'react';
import './copyright.scss';

const Copyright = () => <div className="copyright">© 2018 Inove Sistemas</div>;

export default Copyright;
